import { FieldComponent } from "./chunk-3JUJVI6N.js";
import { TextInput_default } from "./chunk-HHTQGZU6.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/TextField/TextField.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var TEXT_FIELD_CLASSNAME_MAP = {};
var TextField = forwardRef((_a, ref) => {
  var _b = _a,
    {
      id,
      name,
      label,
      required,
      requiredLabel,
      description,
      validation,
      validationMessage,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "label", "required", "requiredLabel", "description", "validation", "validationMessage", "className"]);
  return /* @__PURE__ */jsxs(FieldComponent, {
    id,
    name,
    label,
    required,
    requiredLabel,
    description,
    validation,
    validationMessage,
    className: clsx("pd:text-field", className),
    children: [/* @__PURE__ */jsx(FieldComponent.Label, {
      className: "pd:text-field__label"
    }), /* @__PURE__ */jsx(FieldComponent.Input, __spreadValues({
      ref,
      as: TextInput_default,
      className: "pd:text-field__input"
    }, rest)), /* @__PURE__ */jsx(FieldComponent.ValidationMessage, {
      className: "pd:text-field__validation-message"
    }), /* @__PURE__ */jsx(FieldComponent.Description, {
      className: "pd:text-field__description"
    })]
  });
});
var TextField_default = TextField;
export { TEXT_FIELD_CLASSNAME_MAP, TextField_default };